export const KEYBOARD_CODE = {
  ENTER: 'Enter',
  NUM_ENTER: 'NumpadEnter',
  TAB: 'Tab',
};

// Смещение Dropdown по оси Y относительно нижнего края Toggle
export const DROPDOWN_OFFSET_Y = 8;
